import { createFilterForField, StringFilterSubTypes } from '../Filter';
import { FilterOperators } from '../FilterOperators';
import { IExpressionSegment } from '../../../datasets';

export default field => {
  const filter = createFilterForField(field);
  const NULL = FilterOperators.forFilterType(filter.type).null;
  filter.expression.left.operator = NULL?.key;
  (filter.expression.left as IExpressionSegment).operands = [];
  filter.subType = StringFilterSubTypes.SET_CONDITION;
  return filter;
};
